import React from 'react';
import { BlocksIcon, PresentationIcon, FileCode2Icon } from 'lucide-react';
import { Section } from '../Section';
import { Figure } from '../Figure';
import { Panel } from '../ui/Panel';
import { craftPoints, images } from '../../data/caseStudy';
const icons = [BlocksIcon, PresentationIcon, FileCode2Icon];
export function Craft() {
  return <Section number="05" kicker="Craft" title="The shifting scope" lede="With engineering bandwidth tight, the design work had to reduce load downstream rather than add to it." tone="white" data-id="element-85" data-mp="wu3kiyq9honi">
      <div className="grid grid-cols-3 gap-5" data-id="element-86" data-mp="16pdlrk8u5s08">
        {craftPoints.map((point, i) => {
        const Icon = icons[i];
        return <Panel key={point.title} padding="sm" data-id="element-87" data-mp="1bk11atlv3c2o" data-mpi={i}>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-green-soft" data-id="element-88" data-mp="1gfq6bcgnhl6d">
                <Icon className="h-4 w-4 text-green-deep" aria-hidden="true" data-id="element-89" data-mp="1kjebxplq26oz" />
              </span>
              <h3 className="mt-6 font-display text-[19px] font-semibold leading-tight tracking-[-0.02em] text-navy" data-id="element-90" data-mp="1pihhrc9j0gy0">
                {point.title}
              </h3>
              <p className="mt-3 font-sans text-[14px] leading-[1.7] text-ink-muted" data-id="element-91" data-mp="2kzegv05ey182">{point.body}</p>
            </Panel>;
      })}
      </div>

      <div className="mt-10" data-id="element-92" data-mp="2g0uskt3ckdcj">
        <Figure src={images.components} alt="Component sheet showing the map legend, status chips, empty and selected states of the layer menu, and tooltip variants." caption="Legend, status chips, layer menu states and tooltips documented as one modular set, a scope change meant reconfiguring components, not redrawing screens." label="Component states — legend, layer menu, tooltips" data-id="element-93" data-mp="2g25xiw8j3r58" />
      </div>
    </Section>;
}